import React from 'react';
import 'yuki-createjs';
import { connect } from 'react-redux';
import Char from '../shared/Char';
import CharBtn from '../shared/CharBtn';
import RestartBtn from '../shared/RestartBtn';
import GuidelinesOnBtn from '../shared/GuidelinesOnBtn';
import GuidelinesOffBtn from '../shared/GuidelinesOffBtn';
import { setSpacing, setWordBounds } from '../../../utils/utils';

export class WordTrack extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            array: [],
            isPlaying: true,
            guidelinesShown: true
        };

        createjs.Ticker.on('tick', this.tick, this);
        createjs.Ticker.framerate = 30;
    }
    load() {
        if (this.state.word === 'didnt') {
            this.state.letters = ['d','i','d','n',"'",'t'];
        } else if (this.state.word === 'sunday') {
            this.state.letters = ['S','u','n','d','a','y'];
        } else {
            this.state.letters = [...this.state.word];
        }

        this.state.total = this.state.letters.length;

        this.state.loader = new createjs.LoadQueue(true);
        this.state.loader.on('complete', this.create, this);

        this.state.manifest = [];
        
        for (let i = 0; i < this.state.total; i++) {
            let letterCase = 'lc';

            if (this.state.letters[i] === 'S') {
                letterCase = 'uc';
            }
            
            this.state.manifest.push({
                src: 'images/sections/' + letterCase + '/chars/track/' + this.state.letters[i] + '.json', 
                id: 'word-letter-spritesheet-' + i,
                type: 'spritesheet'
            });
        }

        while (this.state.manifest.length > 0) {
            this.state.loader.loadFile(this.state.manifest.shift());
        }
    }
    create() {
        let _this = this;

        for (var i = 0; i < this.state.total; i++) {
            let cvs = document.getElementById('lc-track-cvs-' + i),
                btn = $('.char-btn', '#word-track');

            this.state.array[i] = new Object();
            this.state.array[i].canvas = cvs;
            this.state.array[i].stage = new createjs.Stage(this.state.array[i].canvas);
            this.state.array[i].anim = new createjs.Sprite(this.state.loader.getResult('word-letter-spritesheet-' + i));
            this.state.array[i].anim.id = i;
            this.state.array[i].btn = btn;

            this.state.array[i].stage.addChild(this.state.array[i].anim);
            this.state.array[i].anim.on('animationend', this.end, this);

            this.state.array[i].btn.on('touchstart mousedown', function() {

                let id = parseInt($(this).attr('id'));

                _this.state.array[id].anim.play();

                $('body').on('touchend mouseup', function() {

                    _this.state.array[id].anim.stop();

                    $('body').off('touchend mouseup');
                });
            });
        }

        $(window).on('resize.word-track', function() {
            _this.resize();
        });

        this.resize();
    }
    end(e) {
        e.target.gotoAndPlay('active');
    }
    tick() {
        if (this.state.array.length) {
            for (var i = 0; i < this.state.total; i++) {
                if (this.state.array[i].stage !== undefined) {
                    this.state.array[i].stage.update();
                }
            }
        }
    }
    pos() {
        const holder = $('.holder-inner', '#word-track'),
            holderBaseW = 447,
            holderBaseH = 104;
        let char = $('.char-holder', '#word-track'),
            charBtn = $('.char-btn', '#word-track'),
            holderW = holder.width(),
            holderH = holder.height(),
            holderPercW = holderW / 100,
            holderPercH = holderH / 100,
            wordW = (this.state.bounds[1] + 3.25) * 0.8,
            wordL = (holderBaseW * 0.5) - (wordW * 0.5),
            wordLPerc = (wordL/holderBaseW) * 100,
            xPos,
            boundsL;

        for (let i = 0; i < this.state.total; i++) {

            boundsL = wordL + (this.state.bounds[2][i]*0.8);
            xPos = (holderPercW * ((boundsL/holderBaseW) * 100));

            char.eq(i).css('left', xPos + 'px');
        }

        for (let j = 0; j < this.state.total; j++) {

            let spacing;

            if (this.state.letters[j] === 'S') {
                spacing = setSpacing(this.state.letters[j], 'uc');
            } else {
                spacing = setSpacing(this.state.letters[j], 'lc');
            }

            let spaceW = (spacing[1] + spacing[3]) * 0.8,
                spaceT = spacing[2] * 0.8,
                spaceH = spacing[4] * 0.8,
                btnTopPerc = (spaceT/holderBaseH) * 100,
                btnTopOffsetPerc = (6 / holderBaseH) * 100,
                btnTop = (holderPercH * btnTopPerc) - (btnTopOffsetPerc * holderPercH),
                btnBaseW = (spacing[3] + 4) * 0.8,
                btnW = holderPercW * ((btnBaseW/holderBaseW) * 100), 
                btnH = holderPercH * ((spaceH/holderBaseH) * 100);

            charBtn.eq(j).css({
                'top': btnTop + 'px',
                'left': char.eq(j).css('left'),
                'width': btnW + 'px',
                'height': btnH + 'px'
            });
        }
    }
    resize() {
        const parent = $('.char-holder'),
            curr = $('.lc-track-cvs');
        let parentW = parent.width(),
            parentH = parent.height(),
            currW = curr.width(),
            currH = curr.height(),
            scale = parentW / currW;

        curr.attr('height', $('#word-track').height() - $('.holder', '#word-track').position().top);
        
        for (var i = 0; i < this.state.total; i++) {
            this.state.array[i].stage.scaleX = scale;
            this.state.array[i].stage.scaleY = scale;
        }

        this.pos();
    }
    play() {
        this.stop();
        if (this.state.array.length) {
            
            this.state.array[0].anim.gotoAndPlay('active');
        }
        this.setState({ isPlaying: true });
    }
    stop() {
        if (this.state.array.length) {
            for (var i = 0; i < this.state.total; i++) {
                this.state.array[i].anim.gotoAndStop('active');
            }
        }
        this.setState({ isPlaying: false });
    }
    guidelinesShow() {
        $('.guidelines', '#word-track').show();
        this.setState({ guidelinesShown: true });
    }
    guidelinesHide() {
        $('.guidelines', '#word-track').hide();
        this.setState({ guidelinesShown: false });
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.word) {
            this.setState({ isPlaying: true });
            this.guidelinesShow();
            this.state.word = nextProps.word;
            this.state.bounds = setWordBounds(nextProps.word);
            this.load();
        }
    }
    componentWillUnmount() {
        $(window).off('resize.word-track');
    }
    render() {
        let btn = '',
            char = '';
        if (this.props.word) {
            btn = 
                [...Array(this.state.total)].map((label, index) => {
                    return (
                        <CharBtn key={index} id={index} />
                    );
                });
            char = 
                [...Array(this.state.total)].map((label, index) => {
                    return (
                        <Char key={index} id={index} charType="lc" animType="track" />
                    );
                });
        }
        return (
            <div id="word-track" className="panel">
                <div className="title"></div>
                <div className="guidelines-txt"></div>
                <GuidelinesOffBtn onClick={this.guidelinesHide.bind(this)} selected={!this.state.guidelinesShown} />
                <GuidelinesOnBtn onClick={this.guidelinesShow.bind(this)} selected={this.state.guidelinesShown} />
                <RestartBtn onClick={this.stop.bind(this)} />
                <div className="holder">
                    <div className="holder-inner">
                        {btn}
                        {char}
                    </div>
                    <div className="guidelines"></div>
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state) => ({
    word: state.word.word
})

export default connect(mapStateToProps, undefined)(WordTrack);




// WEBPACK FOOTER //
// ./src/components/sections/words/WordTrack.js